import * as network from './network';

// Get all homepage sections
const getAllHomepageSections = (params) => {
  return network.get(`api/homepage-sections`, params, true);
};

// Get specific section by key
const getHomepageSection = (sectionKey) => {
  return network.get(`api/homepage-sections/${sectionKey}`, {}, true);
};

// Create/Update section (upsert)
const upsertHomepageSection = (payload) => {
  const isFileUpload = payload instanceof FormData;
  return network.post(`api/homepage-sections`, payload, true, isFileUpload);
};

// Update section status
const updateSectionStatus = (sectionKey, payload) => {
  return network.patch(`api/homepage-sections/${sectionKey}/status`, payload, true);
};

// Add item to list section
const addItemToSection = (sectionKey, payload) => {
  return network.post(`api/homepage-sections/${sectionKey}/items`, payload, true);
};

// Update item in list section
const updateItemInSection = (sectionKey, itemId, payload) => {
  return network.put(`api/homepage-sections/${sectionKey}/items/${itemId}`, payload, true);
};

// Delete item from list section
const deleteItemFromSection = (sectionKey, itemId) => {
  return network.delet(`api/homepage-sections/${sectionKey}/items/${itemId}`, true);
};

// Reorder items
const reorderItems = (sectionKey, payload) => {
  return network.patch(`api/homepage-sections/${sectionKey}/items/reorder`, payload, true);
};

export default {
  getAllHomepageSections,
  getHomepageSection,
  upsertHomepageSection,
  updateSectionStatus,
  addItemToSection,
  updateItemInSection,
  deleteItemFromSection,
  reorderItems,
};
